import { CalendarDays, LayoutGrid, Table as TableIcon } from 'lucide-react'

/**
 * <Segmented> — pick ONE of 2–5 options that change what the list shows
 * (status filter, metric, "ทั้งหมด / ยังไม่เสร็จ"). Audit: 8+ local versions in
 * 3 visual languages. This is the most common one (white box, brand-50 active).
 *
 * options: [{ value, label, icon?, count?, disabled?, title? }]
 * disabled  the whole control (e.g. while a save is running)
 * scroll    many options on a narrow screen: scroll sideways instead of overflowing
 */
export function Segmented({ options, value, onChange, size = 'md', disabled = false, scroll = false, className = '' }) {
  const pad = size === 'sm' ? 'px-2 py-1 text-[12.5px]' : 'px-2.5 py-1.5 text-[13px]'
  const box = (
    <div className={`inline-flex items-center rounded-lg border border-slate-200 bg-white p-0.5 ${disabled ? 'opacity-60' : ''} ${scroll ? '' : className}`} role="radiogroup" aria-disabled={disabled || undefined}>
      {options.map((o) => {
        const on = String(o.value) === String(value)
        const off = disabled || o.disabled
        return (
          <button key={String(o.value)} type="button" role="radio" aria-checked={on} disabled={off} title={o.title} onClick={() => !off && onChange(o.value)}
            className={`inline-flex items-center gap-1.5 rounded-md font-medium whitespace-nowrap transition-colors disabled:cursor-not-allowed ${pad} ${on ? 'bg-brand-50 text-brand-700 ring-1 ring-inset ring-brand-200' : off ? 'text-slate-300' : 'text-slate-500 hover:text-slate-900'}`}>
            {o.icon && <o.icon size={14} />}
            {o.label}
            {o.count != null && <span className={`tabular-nums text-[11.5px] ${on ? 'text-brand-500' : 'text-slate-400'}`}>{o.count}</span>}
          </button>
        )
      })}
    </div>
  )
  return scroll ? <div className={`max-w-full overflow-x-auto no-scrollbar ${className}`}>{box}</div> : box
}

const VIEWS = {
  table: { label: 'ตาราง', icon: TableIcon },
  card: { label: 'การ์ด', icon: LayoutGrid },
  grid: { label: 'รูปย่อ', icon: LayoutGrid },
  calendar: { label: 'ปฏิทิน', icon: CalendarDays },
}

/** Switch how the SAME data is drawn. Remember the choice per page (useFilters). */
export function ViewToggle({ value, onChange, views = ['table', 'card'] }) {
  return <Segmented value={value} onChange={onChange} options={views.map((v) => ({ value: v, ...VIEWS[v] }))} />
}
